// Feature flags ของ frontend — ค่าเดียวกันทุก environment (ห้ามแยก dev/staging/prod)
//
// SNIPPET_SUPALAI_UI: setting ชุดที่พอร์ตมาจาก repo ลูกค้า supalai (commit 3b0edc8b1..ad4a3accf)
// ลูกค้าขอ "ยังไม่เอาตอนนี้" (25 ส.ค. 2026) จึงซ่อนเฉพาะ UI ฝั่ง admin — โค้ด/คอลัมน์/endpoint ยังอยู่ครบ
// คุมแค่หน้า /ServiceTheme กับ /SetupSocial เท่านั้น · ตัว widget (Snippet.vue, ChatFrameworkSnippet.js,
// SnippedPreview.vue) ถูกย้อนหน้าตากลับ baseline แบบถาวร ไม่ได้ผูกกับ flag นี้
// วิธีเปิดกลับ + ผลกระทบทั้งหมด ดู docs/snippet-supalai-ui-hide-plan.md
export const SNIPPET_SUPALAI_UI = false;
